import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {MSG_VALIDATION_ERROR_1,MSG_VALIDATION_ERROR_2,MSG_VALIDATION_ERROR_3,MSG_VALIDATION_ERROR_4,MSG_PASSWORD_REQUIRED, MSG_PWDCONFIRM_REQUIRED, MSG_PASSWORD_MISMATCH} from '../../configs/msgConfigs';
import * as labelConfigs from '../../configs/labelConfigs';
import * as staticConfigs from '../../configs/staticConfigs';
import {URL_IMG,LOGO_URL} from '../../configs/urlConfigs'; 
import {formValid} from '../../utils/validation'; 
import { getStorage, setStorage } from '../../utils/browserStorage';
import { setPasswordAction } from '../../actions/authenticationActions';
import validator from 'validator';

class ResetPasswordComponent extends Component { 

    constructor(props){
        super();

        this.state = { 
            formErrors:{
                txtPassword: MSG_VALIDATION_ERROR_1, 
                txtPwdConfirm: "",  
                txtPwdMismatch: ""      
            },
            userData:{
                txtPassword:null, 
                txtPwdConfirm: null 
            },
            userToken: null,
            userId: null,
            userGroupId:null,
            errorMessage:'',
            crewActivated: 0
        }

       this.handleSave = this.handleSave.bind(this);
       this.handleChange = this.handleChange.bind(this); 
       this.gotoLogin = this.gotoLogin.bind(this); 
    } 

    componentDidMount() {
        document.title = labelConfigs.LBL_APP_NAME+' : Set Password';
        document.body.classList.add('login');

        let uId     = getStorage('user_id'); 
        let uToken  = getStorage('user_token'); 
        let groupId = getStorage('user_group');
        if((!uId) || (!uToken) || (!uToken)) {
            this.setState({errorMessage:' Sorry, Invalid parameters, Please contact Administrator '});     
        }
        else {
            this.setState({userId:uId, userToken:uToken, userGroupId:groupId}); 
        }
    }

    gotoLogin() {
        if (this.state.userGroupId===parseInt(staticConfigs.LOGIN_SUPER_ADMIN_GROUP,10)) {
            setStorage('user_token', '');
            setStorage('user_id', '');
            this.props.history.push(staticConfigs.LOGIN_ROUTE_SUPER_ADMIN); 
        }
        else if (this.state.userGroupId===parseInt(staticConfigs.LOGIN_AFFILIATE_GROUP,10)) {
            setStorage('user_token', '');
            setStorage('user_id', '');
            this.props.history.push(staticConfigs.LOGIN_ROUTE_AFFILIATE); 
        }
        else if (this.state.userGroupId===parseInt(staticConfigs.LOGIN_OMNU_AFFILIATE_GROUP,10)) {
            setStorage('user_token', '');
            setStorage('user_id', '');
            this.props.history.push(staticConfigs.LOGIN_ROUTE_AFFILIATE); 
        }
        else if (this.state.userGroupId===parseInt(staticConfigs.LOGIN_CLIENT_GROUP,10)) {
            setStorage('user_token', '');
            setStorage('user_id', '');
            this.props.history.push(staticConfigs.LOGIN_ROUTE_CLIENT); 
        }
        else if (this.state.userGroupId===parseInt(staticConfigs.LOGIN_CREW_GROUP,10)) {
            setStorage('user_token', '');
            setStorage('user_id', '');
            this.props.history.push(staticConfigs.LOGIN_ROUTE_CREW); 
        }
    }

    validate = (value) => {
  
        if (validator.isStrongPassword(value, {
          minLength: 8, minLowercase: 1,
          minUppercase: 1, minNumbers: 1, minSymbols: 1
        })) {
          return true
        } else {
          return false
        }
    }

    handleChange = (event) =>{
        event.preventDefault();

        const {name,value} = event.target;
        let formErrors     = this.state.formErrors;
        let validated = true
        if(name === 'txtPassword'){
            validated = this.validate(value);
        }
        switch(name){
            case 'txtPassword':
                formErrors.txtPassword = 
                value.length <=0 
                ? MSG_PASSWORD_REQUIRED
                : validated?"":MSG_VALIDATION_ERROR_1
                break;
            case 'txtPwdConfirm':
                    formErrors.txtPwdConfirm = 
                    value.length <=0 
                    ? MSG_PWDCONFIRM_REQUIRED
                    : ""
                break;
            default :
            break;
        }
          
        let userData   = this.state.userData;
        userData[name] = value;

        this.setState({formErrors,userData});
       
    }

    handleSave = (event) => {
        event.preventDefault();      

        if(formValid(this.state)){
            if(this.state.userData.txtPassword.length > 0 && this.state.userData.txtPwdConfirm.length > 0 && this.state.userData.txtPassword!==this.state.userData.txtPwdConfirm) {
                return false; 
            }
            else if(this.state.userData.txtPassword.length > 0 || this.validate(this.state.userData.txtPassword)) { 
                let apiData= {
                    userToken: this.state.userToken,
                    userId: this.state.userId,
                    txtPassword: this.state.userData.txtPassword,
                }
                this.props.dispatch(setPasswordAction(apiData));
            }

        }else{
            let formErrors = this.state.formErrors;
            if(this.state.userData.txtPassword==null){
                formErrors.txtPassword = MSG_PASSWORD_REQUIRED;
            }  
            if(this.state.userData.txtPwdConfirm==null){
                formErrors.txtPwdConfirm = MSG_PWDCONFIRM_REQUIRED;
            } 
            this.setState({formErrors});
        }
    }

    componentDidUpdate(prevProps) {   
        // if(this.props.hasOwnProperty('response') && this.props.response.hasOwnProperty('setPassword')) console.log(this.props.response.setPassword.status+' :: '+this.props.response.setPassword.activity+' :: componentDidUpdate: '+JSON.stringify(this.props.response.setPassword)); 

        if(this.props.hasOwnProperty('response') && this.props.response.hasOwnProperty('setPassword')) {
            const {status,activity} = this.props.response.setPassword;
            if (activity !== prevProps.response.setPassword.activity) {
                if (status===200) {
                    if (this.state.userGroupId===staticConfigs.LOGIN_SUPER_ADMIN_GROUP) {
                        setStorage('user_token', '');
                        setStorage('user_id', '');
                        this.props.history.push(staticConfigs.LOGIN_ROUTE_SUPER_ADMIN); 
                    }
                    else if (this.state.userGroupId===staticConfigs.LOGIN_AFFILIATE_GROUP) {
                        setStorage('user_token', '');
                        setStorage('user_id', '');
                        this.props.history.push(staticConfigs.LOGIN_ROUTE_AFFILIATE); 
                    }
                    else if (this.state.userGroupId===staticConfigs.LOGIN_OMNU_AFFILIATE_GROUP) {
                        setStorage('user_token', '');
                        setStorage('user_id', '');
                        this.props.history.push(staticConfigs.LOGIN_ROUTE_AFFILIATE); 
                    }
                    else if (this.state.userGroupId===staticConfigs.LOGIN_CLIENT_GROUP) {
                        setStorage('user_token', '');
                        setStorage('user_id', '');
                        this.props.history.push(staticConfigs.LOGIN_ROUTE_CLIENT); 
                    }
                    else if (this.state.userGroupId===staticConfigs.LOGIN_CREW_GROUP) {
                        setStorage('user_token', '');
                        setStorage('user_id', '');
                        this.setState({crewActivated: 1}); 
                        // this.props.history.push(staticConfigs.LOGIN_ROUTE_CREW); 
                    } 
                } 
                else if (status===208) { 
                    let groupId  = this.props.response.data.group_id;
                    let userMessage  = this.props.response.data.message;
                    this.setState({userGroupIdId: groupId, showLogin: 1, errorMessage: userMessage}); 
                } 
                // else  if (status===500) {
                //     this.setState({errorMessage: 'Sorry, Password setting failed'});
                // } 
                else  {
                    this.setState({errorMessage: 'Sorry, Password setting failed '});
                }
            }
        }
    }  

    render(){
        
        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="login-logo padding-bottom-0 margin-top-100">                    
                                <Link to="#"><img className="logo-width" src={LOGO_URL} alt="Logo" /></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="login-box">
                    <div className="row">
                        <form className="col-md-12" onSubmit={this.handleSave}>
                            <div className="col-md-12"> 
                                <div className="box">
                                    <div className="tab-head">
                                        <h6 className="text-bold">Set Password</h6>
                                    </div>
                                    <div className="box-content">
                                        {this.state.crewActivated > 0 && 
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group text-center">
                                                    <br></br>
                                                    You  have been activated as a {labelConfigs.LBL_APP_NAME} member successfully, 
                                                    <br></br> <br></br>
                                                    Please install {labelConfigs.LBL_APP_NAME} mobile app to explore this platform.
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        {this.state.crewActivated===0 && 
                                        <React.Fragment>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>New Password</label>
                                                    <div className="text-input"> 
                                                        <input type="password" name="txtPassword" placeholder="New Password"  className={this.state.userData.txtPassword ? '' : "input-error"}  onChange={this.handleChange} autoFocus />
                                                    </div>
                                                    {/*this.state.formErrors.txtPassword.length >0 && (
                                                        <div className="text-red left-align text-12">{this.state.formErrors.txtPassword}</div>
                                                    )*/} 
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Re-Enter New Password</label>
                                                    <div className="text-input">
                                                    <input type="password" name="txtPwdConfirm" placeholder="Re-Enter New Password"  onChange={this.handleChange} className={this.state.userData.txtPwdConfirm ? '' : "input-error"} />
                                                    </div>
                                                    {this.state.formErrors.txtPwdConfirm.length>0 && (
                                                        <div className="text-red left-align text-12">{this.state.formErrors.txtPwdConfirm}</div>
                                                    )}

                                                    {this.state.userData.txtPassword!=null && this.state.userData.txtPwdConfirm!=null && this.state.userData.txtPassword!==this.state.userData.txtPwdConfirm && (
                                                        <div className="text-red left-align text-12">{MSG_PASSWORD_MISMATCH}</div>
                                                    )}
                                                    
                                                </div>
                                            </div>                              
                                        </div>
                                        
                                        <div className="clearfix">
                                            {this.state.errorMessage.length > 1 && (
                                                <div className="text-red center-align text-14">{this.state.errorMessage}</div>
                                            )}
                                            <div>&nbsp;</div>
                                            <button onClick={this.handleSave} className="btn btn-primary float-center">Save</button>
                                            
                                            
                                        </div>
                                         {this.state.formErrors.txtPassword.length>0 && (
                                                    <div className="text-red left-align text-12 display-grid marginTop10">
                                                        <span>{MSG_VALIDATION_ERROR_1}</span>
                                                        <span>{MSG_VALIDATION_ERROR_2}</span>
                                                        <span>{MSG_VALIDATION_ERROR_3}</span>
                                                        <span>{MSG_VALIDATION_ERROR_4}</span>
                                                    </div>
                                                )}
                                        </React.Fragment>
                                        }
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </React.Fragment>
        )

    }
    
}

const mapStateToProps = (response) => ({response});
export default withRouter(connect(mapStateToProps)(ResetPasswordComponent));